import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { CountdownTimerComponent } from '@gains-com/ui-angular';
import { minutesInMs } from '@gains-com/shared';
import { WindowProvider } from '../../core/window.provider';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-app-update',
  templateUrl: './app-update.component.html',
  styleUrl: './app-update.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CountdownTimerComponent, MatButton],
})
export class AppUpdateComponent {
  private readonly _window = inject(WindowProvider);

  endTime = signal(new Date(new Date().getTime() + minutesInMs(10)));

  update() {
    this._window.location.reload();
  }
}
